import { authService } from "../../service/authService";
import { AiOutlinePoweroff } from "react-icons/ai";
import SideBarLink from "./SideBarLink";
import "./SideBar.css";
import { useEffect, useState } from "react";

function SideBar() {
  const [canNotifications, setCanNotifications] = useState(false);
  const [canCoworkers, setCanCoworkers] = useState(false);
  const [canStatistics, setCanStatistics] = useState(false);
  const [canRanking, setCanRanking] = useState(false);
  const [canPartners, setCanPartners] = useState(false);
  const [canBrokers, setCanBrokers] = useState(false);
  const [canCustomers, setCanCustomers] = useState(false);

  useEffect(() => {
    authService.getCurrentUser()
    .then(res => {
      setCanBrokers(isAllowed("canBrokers", res.data));
      setCanCoworkers(isAllowed("canCoworkers", res.data));
      setCanStatistics(isAllowed("canStatistics", res.data));
      setCanRanking(isAllowed("canRanking", res.data));
      setCanPartners(isAllowed("canPartners", res.data));
      setCanCustomers(isAllowed("canCustomers", res.data));
      setCanNotifications(isAllowed("canNotifications", res.data));
    });
  }, [])
  
  const isAllowed = (permission, user) => {
    return user.isAdmin || user[permission];
  }
  
  const onLogout = (formData) => {
    authService.logout(formData);
  };

  return (
    <div className="text-center bg-sidemenu bg-no-repeat">
      <h1 className="m-3 py-4 text-white font-bold">
        IMMOWERT
        <br />
        <span className="text-blue-accent">4YOU</span>
      </h1>
      <ul className="list-unstyled components px-3">
        {canCustomers && <SideBarLink optionName="Benutzer" route="/customers" />}
        {canBrokers && <SideBarLink optionName="Makler" route="/brokers" />}
        {canPartners && <SideBarLink optionName="Kooperationspartner" route="/partners" />}
        {canRanking && <SideBarLink optionName="Rangfolge" route="/ranking" />}
        {canStatistics && <SideBarLink optionName="Statistiken" route="/statistics" />}
        {canCoworkers && <SideBarLink optionName="Mitarbeiter" route="/coworkers" />}
        {canNotifications && <SideBarLink optionName="Angebote" route="/offerts" />}
      </ul>
      <div className="px-3 absolute w-full bottom-5">
        <button
          type="button"
          onClick={onLogout}
          className="text-white py-2 cursor-pointer hover:bg-blue-accent
           transition duration-200 ease-in-out rounded-md w-full flex justify-center items-center"
        >
          <AiOutlinePoweroff className="mr-1" />
          Ausloggen
        </button>
      </div>
    </div>
  );
}

export default SideBar;
